import React from 'react';
import { PencilSVG } from '../../@common_components/svgs/pencil.svg';


const PencilIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <PencilSVG {...props} />;
};

export { PencilIcon };
